__turbopack_context__.v({
  "controlHolder": "SubmitPrizeSection2026-module__NmraqG__controlHolder",
  "textBox": "SubmitPrizeSection2026-module__NmraqG__textBox",
});
